import { render, staticRenderFns } from "./link-mvg-input.vue?vue&type=template&id=08c29dd3&"
import script from "./link-mvg-input.vue?vue&type=script&lang=js&"
export * from "./link-mvg-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports